import React from 'react';
import './index.scss';
const classPrefix = 'image-uploader';
const UploadButton = ({ box = 104, onUpload }) => {
    return (React.createElement("div", { className: `${classPrefix}-upload-button`, onClick: onUpload, style: { width: box, height: box } },
        React.createElement("div", { className: `${classPrefix}-upload-button-icon` },
            React.createElement("svg", { viewBox: '64 64 896 896', focusable: 'false', "data-icon": 'plus', width: '1em', height: '1em', fill: 'currentColor', "aria-hidden": 'true' },
                React.createElement("path", { d: 'M480 480V128a32 32 0 0164 0v352h352a32 32 0 110 64H544v352a32 32 0 11-64 0V544H128a32 32 0 010-64h352z' }))),
        React.createElement("div", { className: `${classPrefix}-upload-button-text` }, "\u4E0A\u4F20\u56FE\u7247")));
};
export default UploadButton;
